// extracted by mini-css-extract-plugin
module.exports = {"coinWallet":"styles_coinWallet__5IkWu","manageMoney":"styles_manageMoney__qLsX5","faq":"styles_faq__Bmveu","wallet__section_faq":"styles_wallet__section_faq__Sv23v"};